export const PAYMENT_STATUSES = {
  PREPARATION: 'PREPARATION',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVAL_REJECTED: 'APPROVAL_REJECTED',
  APPROVED: 'APPROVED',
  PROCESSING: 'PROCESSING',
  PAID: 'PAID',
  PROCESSING_VOID: 'PROCESSING_VOID',
  VOIDED: 'VOIDED',
  DECLINED: 'DECLINED',
} as const;

export type PaymentStatus = (typeof PAYMENT_STATUSES)[keyof typeof PAYMENT_STATUSES];

export const PAYMENT_TAGS = {
  saveForLater: '_S_SAVE_FOR_LATER',
  archive: '_S_ARCHIVED',
  hasRecreatedPayment: '_S_HAS_RECREATED_PAYMENT',
} as const;

export type PaymentTagKey = keyof typeof PAYMENT_TAGS;
export type PaymentTagValue = (typeof PAYMENT_TAGS)[PaymentTagKey];

export const PAYMENT_TAG_LABELS = Object.fromEntries(
  Object.entries(PAYMENT_TAGS).map(([key, value]) => [value, key]),
) as Record<string, string>;
